import { render, staticRenderFns } from "./PanelProductTime.vue?vue&type=template&id=4cd24de4&scoped=true"
import script from "./PanelProductTime.vue?vue&type=script&lang=js"
export * from "./PanelProductTime.vue?vue&type=script&lang=js"
import style0 from "./PanelProductTime.vue?vue&type=style&index=0&id=4cd24de4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd24de4",
  null
  
)

export default component.exports